import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SelectCentroCosto } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const CentroCostoNivel1FormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setFieldValue, updateStore, rowIndex }) => {
  const optionsRef = React.useRef([])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      setTimeout(() => {
        updateStore()
      }, 150)
    },
    [handleChange, updateStore]
  )

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(`select-det-centroCostoNivel2-${rowIndex}`, e)
    },
    [rowIndex]
  )

  const oneRowTrigger = React.useCallback(
    primeraFila => {
      setFieldValue('_idCentroCostoNivel1', primeraFila._id)
    },
    [setFieldValue]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='_idCentroCostoNivel1'>
          {({ field }) => (
            <SelectCentroCosto
              {...field}
              id={`select-det-centroCostoNivel1-${rowIndex}`}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onChange={onChange}
              onKeyDown={onKeyDown}
              nivel={1}
              optionsRef={optionsRef}
              oneRowTrigger={oneRowTrigger}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel1FormGroup)
